import { ReferencePage } from '@modules/apiReference/page/types';
import { ReferenceType } from '@modules/client';
import getApiReferenceTypeLabel from './getApiReferenceTypeLabel';
import getReferenceTypeFromPrefix from './getReferenceTypeFromPrefix';
import prefixEnumIfEnum from './prefixEnumIfEnum';

const getReferenceTooltipDataMapKey = (
  typeAlias: string, // 'Enum.Material', 'CFrame'
  refPage: ReferencePage,
  refType?: ReferenceType,
  noRefTypePrefix?: boolean, // set to true if reference type prefix does not exist
):
  | `${ReferencePage.ApiReferencePage}|${NonNullable<
      ReturnType<typeof getApiReferenceTypeLabel>
    >}|${string}`
  | `${ReferencePage.LuauReferencePage}|${string}`
  | `${ReferencePage.NullReferencePage}|${string}` => {
  let trimmedTypeAlias = typeAlias;
  let determinedRefType = refType;
  if (!noRefTypePrefix) {
    // could have ref type prefix. determine
    const { referenceType: prefixRefType, nonprefixedAliasPart } =
      getReferenceTypeFromPrefix(typeAlias);
    if (prefixRefType) determinedRefType = prefixRefType;
    if (nonprefixedAliasPart) trimmedTypeAlias = nonprefixedAliasPart;
  }
  if (refPage === ReferencePage.ApiReferencePage) {
    if (!determinedRefType || determinedRefType === ReferenceType.GLOBAL)
      throw Error(
        `Defined, non-global refType is required for refPage ${refPage} and typeAlias ${trimmedTypeAlias}, but got ${determinedRefType}`,
      );
    const refTypeLabel = getApiReferenceTypeLabel(determinedRefType);
    if (!refTypeLabel)
      throw Error(`Invalid refTypeLabel: ${refTypeLabel} for typeAlias ${trimmedTypeAlias}`);
    return `${refPage}|${refTypeLabel}|${prefixEnumIfEnum(trimmedTypeAlias, determinedRefType)}`;
  }
  return `${refPage}|${refType ? prefixEnumIfEnum(trimmedTypeAlias, refType) : trimmedTypeAlias}`;
};

export default getReferenceTooltipDataMapKey;
